<template>
  <router-view class="home-content"></router-view>
</template>

<script>

export default {
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {

  },
  beforeDestroy () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
